"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.CollapseAnimation = void 0;
var react_1 = __importDefault(require("react"));
var ramda_1 = require("ramda");
var react_transition_group_1 = require("react-transition-group");
var Container_1 = require("../../components/Container");
var forceRedraw = function (node) {
    // To get offsetHeight force node to recalculate
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    node && node.offsetHeight;
};
var calculateChildrenHeight = function (_a) {
    var childNodes = _a.childNodes;
    return ramda_1.reduce(function (acc, node) {
        return acc + node.clientHeight;
    }, 0, Array.from(childNodes));
};
var CollapseAnimation = function (_a) {
    var collapsed = _a.collapsed, _b = _a.collapsedHeight, collapsedHeight = _b === void 0 ? 0 : _b, _c = _a.duration, duration = _c === void 0 ? 500 : _c, _d = _a.style, style = _d === void 0 ? {} : _d, children = _a.children, rest = __rest(_a, ["collapsed", "collapsedHeight", "duration", "style", "children"]);
    var handleEnter = function (node) {
        node.style.height = collapsedHeight + "px";
    };
    var handleEntering = function (node) {
        var wrapperHeight = calculateChildrenHeight(node);
        node.style.height = wrapperHeight + "px";
    };
    var handleEntered = function (node) {
        node.style.height = 'auto';
    };
    var handleExit = function (node) {
        // This is necessary to set height to auto before to set in pixel
        // else the animation doesn't work
        node.style.height = 'auto';
        var wrapperHeight = calculateChildrenHeight(node);
        node.style.height = wrapperHeight + "px";
        forceRedraw(node);
    };
    var handleExiting = function (node) {
        node.style.height = collapsedHeight + "px";
    };
    // any is a temporary fix for web with check-types
    return (react_1["default"].createElement(react_transition_group_1.Transition, { "in": collapsed, onEnter: handleEnter, onEntering: handleEntering, onEntered: handleEntered, onExit: handleExit, onExiting: handleExiting, timeout: duration }, function () { return (react_1["default"].createElement(Container_1.Container, __assign({ style: __assign({ overflow: 'hidden', transitionProperty: 'height', transitionDuration: duration + "ms", height: !collapsed ? collapsedHeight : undefined }, style) }, rest), children)); }));
};
exports.CollapseAnimation = CollapseAnimation;
//# sourceMappingURL=CollapseAnimation.js.map